export default __webpack_public_path__ + "static/media/trainers.9076c630.svg";